export enum UnitOfMeasure {
  cm,
  kg,
  lb,
}
